/* eslint-disable */
import { Box } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
// import router from react

const ChartWrapper = {
  width: "100%",
  height: 200,
  "& .recharts-responsive-container": {
    "& .recharts-wrapper": {
      "& .recharts-legend-wrapper": {
        bottom: "-15px !important",
        "& ul": {
          "& li": {
            marginRight: "18px !important",
            "&:last-of-type": {
              marginRight: "0px !important",
            },
          },
        },
      },
    },
  },
};

function Chart({ projectId, srapySessionData }) {
  const [size, setsize] = useState(210);
  const [selectedLine, setSelectedLine] = useState(null);
  const handleLegendClick = event => {
    const { dataKey } = event;
    setSelectedLine(prev => (prev === dataKey ? null : dataKey)); // Toggle selection
  };

  let graphData = [];
  if (Array.isArray(srapySessionData)) {
    graphData = (srapySessionData || [])
      .map(
        (data, index) =>
          !data?.isFailed &&
          data?.isCompleted && {
            Issues: data.issues || 0,
            Warning: data.warnings || 0,
            Notices: data.notices || 0,
            createdAt: data.createdAt || 0,
            ReportNo: index,
          },
      )
      .filter(Boolean);

    graphData.reverse();
  }
  return (
    <Box sx={ChartWrapper}>
      <ResponsiveContainer width="100%" height={size}>
        <LineChart data={graphData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <Tooltip />
          <Legend onClick={handleLegendClick} wrapperStyle={{ cursor: "pointer" }} />
          <Line type="monotone" dataKey="Issues" stroke="#EA521D" activeDot={{ r: 8 }} strokeWidth={2} strokeOpacity={selectedLine && selectedLine !== "Issues" ? 0.2 : 1} />
          <Line type="monotone" dataKey="Warning" stroke="#FFD700" strokeWidth={2} strokeOpacity={selectedLine && selectedLine !== "Warning" ? 0.2 : 1} />
          <Line type="monotone" dataKey="Notices" stroke="#0057B7" strokeWidth={2} strokeOpacity={selectedLine && selectedLine !== "Notices" ? 0.2 : 1} />
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );
}

export default Chart;
